import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Constants } from '../../../../../../../core/services/constants.service';
import { AutocompleteComponent } from '../../../../../../../shared/components/auto-complete/auto-complete.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpService } from '../../../../../../../core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-buyer-info-edit',
  templateUrl: './buyer-info-edit.component.html',
  styleUrls: ['./buyer-info-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuyerInfoEditComponent implements OnInit {
  submitted: any;
  buyerInfoForm: any;
  public style = 'padding: 20px 10px; border: 1px solid #161616; width: 43%; outline: none; borderRadius: 4px; marginBottom: 20px;background:#161616;color:#dedede;font-size:16px';

  constants = Constants;

  newPropertyId: any;


  noPropertySelected: any;


  @ViewChild(AutocompleteComponent) private autocomplete: AutocompleteComponent;

  constructor(private dialogRef: MatDialogRef<any>,
    private httpService: HttpService,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.buyerInfoForm = this.fb.group({
      title: ['', [Validators.required]],
      firstName: ['', [
        Validators.required,
        Validators.minLength(Constants.MIN_FIRSTNAME_LENGTH),
        Validators.maxLength(Constants.MAX_FIRSTNAME_LENGTH)
      ]],
      lastName: ['', [
        Validators.required,
        Validators.minLength(Constants.MIN_LASTNAME_LENGTH),
        Validators.maxLength(Constants.MAX_LASTNAME_LENGTH)
      ]],
      email: ['', [
        Validators.required,
        Validators.pattern(Constants.EMAIL_REGEX),
        Validators.maxLength(Constants.MAX_EMAIL_LENGTH)
      ]],
      phoneNumber: ['', [
        Validators.required,
        Validators.pattern(Constants.PHONE_REGEX),
        Validators.minLength(Constants.MIN_PHONE_NUMBER_LENGTH),
        Validators.maxLength(Constants.MAX_PHONE_NUMBER_LENGTH)
      ]],
      street: ['', [
        Validators.maxLength(Constants.MAX_ADDRESS_LINE2_LENGTH)
      ]],
      suburb: ['', [
        Validators.maxLength(Constants.MAX_AREA_LENGTH)
      ]],
      state: ['', [
        Validators.maxLength(Constants.MAX_STATE_LENGTH)
      ]],
      postCode: ['', [
        Validators.maxLength(Constants.MAX_POSTCODE_LENGTH)
      ]],
      country: ['', [
        Validators.maxLength(Constants.MAX_COUNTRY_LENGTH)
      ]],
      firb: ['', [Validators.required]],
      isLocalInvestor: ['', [Validators.required]],
      isLocalFirstHomeBuyer: ['', [Validators.required]],
      isLocalDownsize: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    console.log(this.data);
    this.newPropertyId = this.data.property.id;
    this.buyerInfoForm.patchValue({
      firstName: this.data.buyer.firstName,
      lastName: this.data.buyer.lastName,
      email: this.data.buyer.email,
      phoneNumber: this.data.buyer.phoneNumber,
      title: this.data.buyer.title,
      street: this.data.buyer.addressLine2 ? this.data.buyer.addressLine2 : '',
      suburb: this.data.buyer.area ? this.data.buyer.area : '',
      state: this.data.buyer.state ? this.data.buyer.state : '',
      postCode: this.data.buyer.postCode ? this.data.buyer.postCode : '',
      country: this.data.buyer.country ? this.data.buyer.country : '',
      firb: this.data.buyer.FIRB === 0 ? 0 : 1,
      isLocalInvestor: this.data.buyer.localInvestor === 0 ? 0 : 1,
      isLocalFirstHomeBuyer: this.data.buyer.localFirstHomeBuyer === 0 ? 0 : 1,
      isLocalDownsize: this.data.buyer.localDownsize === 0 ? 0 : 1,
    });
  }

  get f() {
    return this.buyerInfoForm.controls;
  }

  submit() {
    this.submitted = true;
    if (this.buyerInfoForm.invalid || !this.newPropertyId) {
      if (!this.newPropertyId) {
        this.noPropertySelected = true;
      }
      return;
    }

    const fd = new FormData();
    // fd.append('propertyId', this.data.property.id);
    fd.append('projectId', this.data.project.id);
    fd.append('title', this.buyerInfoForm.get('title').value);
    fd.append('firstName', this.buyerInfoForm.get('firstName').value);
    fd.append('lastName', this.buyerInfoForm.get('lastName').value);
    fd.append('phoneNumber', this.buyerInfoForm.get('phoneNumber').value);
    fd.append('email', this.buyerInfoForm.get('email').value);
    if (this.buyerInfoForm.get('street').value) {
      fd.append('addressLine2', this.buyerInfoForm.get('street').value);
    }
    if (this.buyerInfoForm.get('suburb').value) {
      fd.append('area', this.buyerInfoForm.get('suburb').value);
    }
    if (this.buyerInfoForm.get('state').value) {
      fd.append('state', this.buyerInfoForm.get('state').value);
    }
    if (this.buyerInfoForm.get('country').value) {
      fd.append('country', this.buyerInfoForm.get('country').value);
    }
    if (this.buyerInfoForm.get('postCode').value) {
      fd.append('postCode', this.buyerInfoForm.get('postCode').value);
    }
    console.log(this.buyerInfoForm.get('firb').value);
    if (this.buyerInfoForm.get('firb').value === 0) {
      fd.append('firb', '0');
      fd.append('localInvestor', this.buyerInfoForm.get('isLocalInvestor').value);
      fd.append('localFirstHomeBuyer', this.buyerInfoForm.get('isLocalFirstHomeBuyer').value);
      fd.append('localDownsize', this.buyerInfoForm.get('isLocalDownsize').value);
    }
    if (this.buyerInfoForm.get('firb').value === 1) {
      fd.append('firb', '1');
    }
    fd.append('originalPropertyId', this.data.property.id);
    if (this.newPropertyId !== this.data.property.id) {
      fd.append('newPropertyId', this.newPropertyId);
    }

    this.httpService.editBuyerInfo(this.data.buyer.id, fd).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.toastrService.success('Buyer has been updated');
        this.dialogRef.close({ code: 1, buyer: res.data, isPropertyChanged: this.newPropertyId !== this.data.property.id });
      } else {
        this.toastrService.error('Failed to update buyer');
      }
    });

  }


  getAddress(address: any) {
    this.autocomplete.clear();
    const components = address.address_components;
    let addressLine2 = '';
    let area = '';
    let city = '';
    let state = '';
    let country = '';
    let postCode = '';
    components.forEach((component: { long_name: string; short_name: string; types: Array<string> }) => {
      if (component.types.find(type => type === 'street_number')) {
        addressLine2 = component.long_name;
      } else if (component.types.find(type => type === 'route')) {
        addressLine2 += ' ' + component.long_name;
      } else if (component.types.find(type => type === 'locality')) {
        area = component.long_name;
      } else if (component.types.find(type => type === 'administrative_area_level_2')) {
        city = component.short_name;
      } else if (component.types.find(type => type === 'administrative_area_level_1')) {
        state = component.short_name;
      } else if (component.types.find(type => type === 'country')) {
        country = component.long_name;
      } else if (component.types.find(type => type === 'postal_code')) {
        postCode = component.long_name;
      }
    });
    console.log(address);
    this.buyerInfoForm.get('street').setValue(addressLine2);
    this.buyerInfoForm.get('suburb').setValue(area);
    this.buyerInfoForm.get('state').setValue(state);
    this.buyerInfoForm.get('country').setValue(country);
    this.buyerInfoForm.get('postCode').setValue(postCode);
    this.cdr.detectChanges();

    //   this.getCoordinatesFromAddress(this.reactiveForm.get('addressLine2').value + ' ' + this.reactiveForm.get('area').value + ' ' + this.reactiveForm.get('city').value + ' ' + this.reactiveForm.get('postCode').value)
    //     .subscribe((coordinate: any) => {
    //       console.log(coordinate);
    //       this.selectedLat = coordinate.lat;
    //       this.selectedLng = coordinate.lng;
    //       // fd.append('latitude', coordinate.lat);
    //       // fd.append('longitude', coordinate.lng);
    //     });
    //   this.cdr.detectChanges();
    // }
  }

  firbChanged(e) {
    console.log(e);
    if (e.value === 1) {
      this.buyerInfoForm.patchValue({
        isLocalInvestor: '0',
        isLocalFirstHomeBuyer: '0',
        isLocalDownsize: '0'
      });
    } else {
      this.buyerInfoForm.patchValue({
        isLocalInvestor: '',
        isLocalFirstHomeBuyer: '',
        isLocalDownsize: ''
      });
    }
  }

  getNewPropertyId(e) {
    console.log(e);
    this.newPropertyId = e.newPropertyId;
    if (this.newPropertyId) {
      this.noPropertySelected = false;
    }
  }
}
